// Live viewing counter
let viewingCount = 76;
const viewingEl = document.getElementById('viewing-count');

function fluctuateViewing() {
  const delta = Math.floor(Math.random() * 5) - 2;
  viewingCount = Math.max(48, Math.min(127, viewingCount + delta));
  if (viewingEl) viewingEl.textContent = viewingCount;
}
setInterval(fluctuateViewing, 3500);

// Quantity selector
// Quantity selector
let supplyQty = 1;

function changeSupplyQty(delta) {
  supplyQty = Math.max(1, Math.min(10, supplyQty + delta));
  document.getElementById('qty-display').textContent = supplyQty;
  document.getElementById('quantity-input').value = supplyQty;
}


// Supply add to cart (mocked for preview)
function addSupplyToCart() {
  const selected = document.querySelector('input[name="supply"]:checked');
  if (!selected) return;
  const tierQty = parseInt(selected.value, 10);
  const totalQty = tierQty * supplyQty;

  const tierData = {
    1: { name: '1 Month Supply', price: 34.00, save: 5.00 },
    2: { name: '2 Months Supply', price: 53.72, save: 24.28 },
    3: { name: '3 Months Supply', price: 71.40, save: 45.60 }
  };
  const t = tierData[tierQty];

  const btn = document.getElementById('supply-add-btn');
  const orig = btn.textContent;
  btn.textContent = 'ADDING...';
  btn.disabled = true;

  setTimeout(() => {
    addItemToCart({
      name: t.name + (supplyQty > 1 ? ` × ${supplyQty}` : ''),
      qty: totalQty,
      price: t.price * supplyQty,
      save: t.save * supplyQty,
      icon: '🍏'
    });
    btn.textContent = '✓ Added!';
    setTimeout(() => {
      btn.textContent = orig;
      btn.disabled = false;
      openCart();
    }, 600);
  }, 400);
}

// Stack add to cart
function addStack(qty, button) {
  const orig = button.textContent;
  button.textContent = 'ADDING...';
  button.disabled = true;

  const stackData = {
    1: { name: 'The Starter', price: 34.00, save: 5.00 },
    2: { name: 'The Transformer', price: 53.72, save: 24.28 },
    3: { name: 'The Queen Stack', price: 71.40, save: 45.60 }
  };
  const s = stackData[qty];

  setTimeout(() => {
    addItemToCart({
      name: s.name + ` (${qty}-pack)`,
      qty: qty,
      price: s.price,
      save: s.save,
      icon: qty === 3 ? '👑' : qty === 2 ? '🔥' : '🌱'
    });
    button.textContent = '✓ Added!';
    setTimeout(() => {
      button.textContent = orig;
      button.disabled = false;
      openCart();
    }, 600);
  }, 400);
}

// Cart logic
const cart = [];
function addItemToCart(item) {
  cart.push(item);
  renderCart();
  updateCartBadge();
}

function renderCart() {
  const itemsEl = document.getElementById('cart-items');
  const footerEl = document.getElementById('cart-footer');

  if (cart.length === 0) {
    itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Add Pure AF Creatine Gummies to get started.</div>';
    footerEl.style.display = 'none';
    return;
  }

  let total = 0, totalSavings = 0, html = '';
  cart.forEach((item) => {
    total += item.price;
    totalSavings += item.save;
    html += `
      <div class="cart-item">
        <div class="cart-item-img">${item.icon}</div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.name}</div>
          <div class="cart-item-qty">${item.qty} bag${item.qty > 1 ? 's' : ''}</div>
        </div>
        <div class="cart-item-price">$${item.price.toFixed(2)}</div>
      </div>
    `;
  });

  if (totalSavings > 0) {
    html += `<div class="cart-discount"><span>Bundle savings</span><span>− $${totalSavings.toFixed(2)}</span></div>`;
  }

  itemsEl.innerHTML = html;
  document.getElementById('cart-total').textContent = '$' + total.toFixed(2);
  footerEl.style.display = 'block';
}

function updateCartBadge() {
  const badge = document.getElementById('cart-badge');
  badge.textContent = cart.reduce((sum, i) => sum + i.qty, 0);
}

function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
}

function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
}

function scrollToSupply() {
  document.querySelector('.hero').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// FAQ
function toggleFaq(el) {
  const item = el.parentElement;
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}



function playVideo() {
//   alert('Preview only — video would play here.\n\nIn production, replace this with a real <video> tag (download IG video → upload to Shopify Files → set src to CDN URL).');
}

// Hero image swap on thumbnail click
function swapHeroImage(thumbEl) {
  const newSrc = thumbEl.getAttribute('data-src');
  const mainImg = document.getElementById('hero-main-image');

  document.querySelectorAll('.thumb-row').forEach(t => t.classList.remove('active'));
  thumbEl.classList.add('active');

  mainImg.classList.add('swapping');
  setTimeout(() => {
    mainImg.src = newSrc;
    mainImg.classList.remove('swapping');
  }, 250);
}

// Feature box tab switching
function switchTab(tabEl) {
  const target = tabEl.getAttribute('data-tab');

  // Update active tab
  document.querySelectorAll('.feature-tab').forEach(t => t.classList.remove('active'));
  tabEl.classList.add('active');

  // Update active panel
  document.querySelectorAll('.feature-panel').forEach(p => p.classList.remove('active'));
  document.querySelector(`.feature-panel[data-panel="${target}"]`).classList.add('active');
}

// Quick FAQ toggle (top-of-page mini-FAQ)
function toggleQuickFaq(el) {
  const item = el.parentElement;
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.quickfaq-item').forEach(i => {
    i.classList.remove('open');
    const tgl = i.querySelector('.quickfaq-toggle');
    if (tgl) tgl.textContent = '+';
  });
  if (!isOpen) {
    item.classList.add('open');
    item.querySelector('.quickfaq-toggle').textContent = '×';
  }
}